$(() => {
  if ($('[type=checkbox]').length > 0) {
    $('[data-action="select-all"]').click(function(e){
      e.preventDefault();
      $('.check-all-item').prop('checked', true);
    });

    $('[data-action="clear-all"]').click(function(e){
      e.preventDefault();
      $('.check-all-item').prop('checked', false);
    });  
  }

  if($('.checkbox-group.required').length > 0){
    $('button[type="submit"]').on('click', function(event){
      // using the html5 validation by changing the required properties
      var $cbx_group = $('.checkbox-group.required').children("input");
      $cbx_group.prop('required', true);
      if($cbx_group.is(":checked")){
        $cbx_group.prop('required', false);
      }
    });
  }

  $('td.checkbox-cell').click(function(){
    let cb = $(this).find('input[type=checkbox]');
    if (cb) {
      cb.click();
    }
  });

  $('td.checkbox-cell input[type=checkbox]').click(function(e) {
    e.stopPropagation();
  });

});
